export const openminedLink = 'https://openmined.org';
export const discussionLink =
  'https://github.com/OpenMined/courses/discussions';
export const mentorshipLink = 'https://mentorship.openmined.org';
export const placementsLink = 'https://placements.openmined.org';
export const slackLink = 'https://slack.openmined.org';
export const blogLink = 'https://blog.openmined.org';
export const githubLink = 'https://github.com/OpenMined';
export const issuesLink = 'https://github.com/OpenMined/openmined/issues';
export const opencollectiveLink = 'https://opencollective.com/openmined';
export const mentorratesLink =
  'https://www.notion.so/openmined/822b6f0510a644bab826eccb1ac3a477?v=69f88b18cdbd4410af89615043c1b983';
export const mentorfaqLink =
  'https://www.notion.so/openmined/FAQs-ddb46eca6ab143f6af3a6314f30ff1b5';
export const shiftscheduleLink =
  'https://www.notion.so/openmined/Shifts-Schedule-f4fb33227f9f4acc9c1ec65a80aff5ca';
export const codeofconductLink =
  'https://github.com/OpenMined/.github/blob/master/CODE_OF_CONDUCT.md';
